// Libraries
import { action, computed } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";

// Custom
import { PlygeneStandardModel } from "Custom/Models/Domain/ProductSelector/SubModels/GutterSystemSubModels/PlygeneProductModels/PlygeneStandard";

export class PlygeneStandardViewModel extends ViewModelBase<PlygeneStandardModel> {
    constructor(model: PlygeneStandardModel) {
        super(model);
    }

    // #region Product Properties

    @computed
    public get gutterLengthMeterage(): number {
        return this.model.gutterLengthMeterage;
    }

    @computed
    public get girth(): number {
        return this.model.girth;
    }

    @action
    public setGutterLengthMeterage = (value: number): void => {
        this.model.gutterLengthMeterage = value;
    };

    @action
    public setGirth = (value: number): void => {
        this.model.girth = value;
    };

    // #region Product Properties

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<PlygeneStandardModel>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
